import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowSpinLeft12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconArrowSpinLeft12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M10.264 10.291a.45.45 0 0 1-.9 0v-.309c-.367.351-.834.626-1.302.825-.876.372-1.915.547-2.721.407-1.459-.255-2.425-.817-2.805-1.195a.45.45 0 0 1 .635-.637c.214.213.992.713 2.324.945.59.103 1.451-.024 2.216-.348.538-.229.95-.524 1.198-.834l-.673.128a.45.45 0 0 1-.169-.884L9.73 8.07l.535-.101zM6 3.917c1.156 0 2.095.937 2.095 2.094l-.011.214a2.095 2.095 0 0 1-4.178-.214c0-1.156.938-2.094 2.094-2.094m0 .9a1.193 1.193 0 1 0 0 2.387 1.193 1.193 0 0 0 0-2.387M3.949 1.214C4.826.842 5.865.666 6.671.807c1.459.254 2.425.816 2.805 1.195a.45.45 0 0 1-.635.637c-.214-.213-.992-.713-2.324-.946-.59-.103-1.452.024-2.216.349-.538.228-.95.524-1.198.834l.672-.129a.45.45 0 0 1 .17.885l-1.662.317-.535.102V1.729a.45.45 0 0 1 .9 0v.31c.367-.352.834-.627 1.301-.825"
            />
        </svg>
    );
}
export default memo(IconArrowSpinLeft12);
